module.exports = __webpack_public_path__ + "rfm-avatar-occasional.svg?252bff239e58154054a3a69066c4cce2";